/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import { onOpenTyreSizeConfiguratorClick } from '../../../_views/configurator_buttons/configurator_buttons';

function TyreSizeConfiguratorButton(props) {
  const { className } = props;
  return (
    <div
      className="configurator-alternative"
      onClick={(evt) => {
        evt.preventDefault();
        onOpenTyreSizeConfiguratorClick(true);
      }}
    >
      <div className="icon icon--tyre-size"></div>
      <Translation translationKey={'configurator-button-search-by-tyre-size'} className={className} tagName="div" />
    </div>
  );
}

TyreSizeConfiguratorButton.propTypes = {
  className: PropTypes.string,
};

TyreSizeConfiguratorButton.defaultProps = {
  className: 'configurator-size-car',
};

export default TyreSizeConfiguratorButton;
